import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
// import AlertContext from "../../context/alert/AlertContext";
// import ConfigContext from "../../context/config/ConfigContext";
import NavigationContext from "../../context/navigation/NavigationContext";
import "./CardPayment.css";
import NumberFormat from "react-number-format";
import ConfigContext from "../../context/config/ConfigContext";
import { CreditCardConfig } from "./CreditCardConfig.js";
import { env } from "../../env";

const CardPayment = (props) => {
  // const alertContext = useContext(AlertContext);
  const configContext = useContext(ConfigContext);
  const { getConfigValueByName } = configContext;
  // const { setAlert, clearAlerts } = alertContext;
  const navigationContext = useContext(NavigationContext);
  const { setFieldRefs } = navigationContext;
  const [maskedInput, setMaskedInput] = useState("");
  // const [edit, setEdit] = useState(false);

  const { paymentChange, onBlur, preserveCardNumber, prevCard, cardNoChange } =
    props;

  let { firstName, lastName, cardNumber, month, year } = props.payment;

  const [labels, setLabels] = useState({
    firstname: "",
    lastname: "",
    creditCardNumber: "",
    expirationDate: "",
    securityCode: "",
  });

  const [cards, setCards] = useState({
    visa: "",
    master: "",
    amex: "",
    discover: "",
  });

  useEffect(() => {
    console.log("credit cards", cards);
  }, [cards]);

  const API_RESOURCES = env.REACT_APP_HMW_API_RESOURCES;
  let getCreditCardConfig = async () => {
    try {
      let resp = await CreditCardConfig();
      console.log("RESP---->", resp);

      const cardDetails = (card) => {
        return resp.filter((ele) => ele.title === card).map((ele) => ele);
      };

      const visa = cardDetails("visa");
      const master = cardDetails("master");
      const amex = cardDetails("amex");
      const discover = cardDetails("discover");
      setCards({ visa, master, amex, discover });
    } catch (err) {
      console.log("Error in getting gallery config");
    }
  };

  useEffect(() => {
    setFieldRefs({
      payment: {
        cardholdername: cardholdernameRef,
        firstName: firstNameRef,
        lastName: lastNameRef,
        cardNumber: cardNumberRef,
        month: monthRef,
        year: yearRef,
        cvvCode: cvvCodeRef,
      },
    });
    let firstname = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.firstname"
    );
    let lastname = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.lastname"
    );
    let creditCardNumber = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.creditCardNumber"
    );
    let expirationDate = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.expirationDate"
    );
    let securityCode = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.securityCode"
    );
    setLabels({
      ...labels,
      firstname,
      lastname,
      creditCardNumber,
      expirationDate,
      securityCode,
    });
    getCreditCardConfig();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log("ELE visa --", cards);

  const cardholdernameRef = useRef(null);
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const cardNumberRef = useRef(null);
  const monthRef = useRef(null);
  const yearRef = useRef(null);
  const cvvCodeRef = useRef(null);

  const enableEdit = () => {
    console.log("Enable", prevCard()?.charAt(0));
    if (prevCard()?.charAt(0) === "#") {
      const card = prevCard().substr(-4);
      console.log("card Last Four Digits", typeof card);
      cardNoChange(card);
      cardNumber = card;
      setMaskedInput("");
    } else {
      const lastFourDigits = prevCard()?.substr(-4);
      console.log("Last Four Digits", lastFourDigits);
      console.log("Enable Input");
      setMaskedInput("");
    }
  };
  const maskInput = async (e, label) => {
    console.log("Mask Input");
    preserveCardNumber(cardNumber);
    await onBlur(e, label);
    if (cardNumber !== "" && cardNumber.length > 4) {
      setMaskedInput("#".repeat(cardNumber.length - 4) + cardNumber.substr(-4));
    } else {
      setMaskedInput("");
    }
    console.log("Masked Value:", maskedInput);
    // setEdit(false);
  };

  return (
    <Fragment>
      <div id="payment" className="payment__formBody">
        {props.title && (
          <div className="billing__cardList__cardSection__title">
            {props.title}
          </div>
        )}
        <form>
          <div className="payment__formBody__formGroup">
            <label htmlFor="firstName">
              {labels.firstname}
              <span className="required" aria-label="Input required">
                (*Required)
              </span>
              :{" "}
            </label>
            <input
              type="text"
              name="firstName"
              id="firstName"
              className="form-control"
              placeholder={labels.firstname}
              onChange={paymentChange}
              value={firstName}
              ref={firstNameRef}
              onBlur={onBlur}
            />
          </div>
          <div className="payment__formBody__formGroup">
            <label htmlFor="lastName">
              {labels.lastname}
              <span className="required" aria-label="Input required">
                (*Required)
              </span>
              :{" "}
            </label>
            <input
              type="text"
              name="lastName"
              id="lastName"
              className="form-control"
              placeholder={labels.lastname}
              onChange={paymentChange}
              value={lastName}
              ref={lastNameRef}
              onBlur={onBlur}
            />
          </div>
          {cards.visa !== "" && (
            <div className="payment__formBody__cardIcons">
              {(!cardNumber || props.getCardType(cardNumber) === "visa") && (
                <img
                  src={API_RESOURCES + cards.visa[0].image}
                  className="payment__formBody__cardIcons__icon"
                  aria-label={cards.visa[0].title + " card"}
                />
              )}
              {(!cardNumber || props.getCardType(cardNumber) === "master") && (
                <img
                  src={API_RESOURCES + cards.master[0].image}
                  className="payment__formBody__cardIcons__icon"
                  aria-label={cards.master[0].title + " card"}
                />
              )}
              {(!cardNumber || props.getCardType(cardNumber) === "amex") && (
                <img
                  src={API_RESOURCES + cards.amex[0].image}
                  className="payment__formBody__cardIcons__icon"
                  aria-label={cards.amex[0].title + " card"}
                />
              )}
              {(!cardNumber ||
                props.getCardType(cardNumber) === "discover") && (
                <img
                  src={API_RESOURCES + cards.discover[0].image}
                  className="payment__formBody__cardIcons__icon"
                  aria-label={cards.discover[0].title + " card"}
                />
              )}
            </div>
          )}
          <div className="payment__formBody__formGroup">
            <label htmlFor="cardNumber">
              {labels.creditCardNumber}
              <span className="required" aria-label="Input required">
                (*Required)
              </span>
              :{" "}
            </label>
            <NumberFormat
              name="cardNumber"
              id="cardNumber"
              type="text"
              displayType="input"
              isNumericString={true}
              className="form-control"
              placeholder={labels.creditCardNumber}
              onValueChange={(values) => {
                const lastFourDigits = prevCard()?.substr(-4);
                if (values.value !== lastFourDigits) {
                  console.log("VAL__>", values.value);
                  cardNoChange(values.value);
                }
              }}
              getInputRef={cardNumberRef}
              value={maskedInput ? maskedInput : cardNumber}
              onFocus={enableEdit}
              onBlur={(e) => maskInput(e, labels.creditCardNumber)}
              format="#### #### #### ####"
              autoComplete="cc-number"
            />
          </div>
          <div className="payment__formBody__formGroup__expiry">
            <div className="payment__formBody__formGroup__expiry__label">
              <label className="label">{labels.expirationDate} </label>
              <div>
                <label htmlFor="expiration month"> mm</label>/
                <label htmlFor="expiration year">yy</label>
              </div>
              <span className="required" aria-label="Input required">
                (*Required)
              </span>{" "}
              :
            </div>
            <div className="payment__formBody__formGroup__expiry__control">
              <select
                name="month"
                id="expiration month"
                className="form-control"
                placeholder={labels.expirationDate}
                onChange={paymentChange}
                value={month}
                ref={monthRef}
                onBlur={(e) => onBlur(e, "Month")}
              >
                <option value="">Month</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </select>
              <select
                name="year"
                id="expiration year"
                className="form-control"
                onChange={paymentChange}
                value={year}
                ref={yearRef}
                onBlur={(e) => onBlur(e, "Year")}
              >
                <option value="">Year</option>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
                <option value="2030">2030</option>
              </select>
            </div>
          </div>
          <div className="payment__formBody__formGroup">
            <label htmlFor="cvvCode">
              {labels.securityCode}
              <span className="required" aria-label="Input required">
                (*Required)
              </span>
              :{" "}
            </label>
            <input
              type="password"
              maxLength="4"
              name="cvvCode"
              id="cvvCode"
              className="form-control"
              placeholder={labels.securityCode}
              onChange={paymentChange}
              ref={cvvCodeRef}
              onBlur={onBlur}
              autoComplete="off"
            />
          </div>
        </form>
      </div>
    </Fragment>
  );
};

export default CardPayment;
